// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import UserAddDialog from './UserAddDialog';
import SearchDomainUserDialog from './SearchDomainUserDialog';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import IconButton from '@mui/material/IconButton';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CheckIcon from '@mui/icons-material/Check';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveAlt1Icon from '@mui/icons-material/PersonRemoveAlt1';
import EditIcon from '@mui/icons-material/Edit';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import ConfirmDialog from './ConfirmDialog';



import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export default function UserTab(props) {
  const { sysID } = props;


  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");



  const [gridData, setGridData] = useState([]);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  useEffect(() => {
    // console.log("useEffect UserTab[didMount]");

    refreshData();

  }, []);

  const [depts, setDepts] = useState([]);

  const refreshData = async () => {

    setShowLoading(true);

    try {
      setSelectedRec(null);
      if (gridApi)
        gridApi.deselectAll();

      const [vDepts, vMembers] = await Promise.all([
        DmsService.deptListGetPromise(gState.sessionID, sysID),
        DmsService.getMembersPromise(gState.sessionID, sysID, true),
      ]);

      setShowLoading(false);

      setDepts(vDepts);


      const vData = vMembers.map(item => {
        return {
          ...item,
          DisplayName: `${item.FullName} ${item.Status == false ? "(Disabled)" : ""}`,
          DataAdmin: ((item.AdminGrade & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData),
          SecurityAdmin: ((item.AdminGrade & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity),
        }
      });

      setGridData(vData);

    } catch (e) {
      setShowLoading(false);

      setGridData([]);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);
    }

  }

  const [openSearchDomainUserDialog, setOpenSearchDomainUserDialog] = useState(false);

  const handleAddDomainUserClick = async () => {
    setOpenSearchDomainUserDialog(true);
  };


  const [openUserAddDialog, setOpenUserAddDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [isDomainUser, setIsDomainUser] = useState(false);

  const handleSelectedDomainUser = (aUserRec) => {
    // console.log("handleSelectedDomainUser", aRec);

    setOpenSearchDomainUserDialog(false);

    const vFindUser = gridData.find(u => u.UserID.toLowerCase() == aUserRec.LoginID.toLowerCase());
    // console.log("vFindUser", vFindUser);

    if (vFindUser) {
      setErrMsg("UserID already exists!");
      setShowError(true);
    } else {
      setEditMode(false);

      const vFindDept = depts.find(d => d.DeptCode == aUserRec?.Department || d.DeptName == aUserRec?.Department);

      const vUserInfo = {
        userID: aUserRec?.LoginID || "",
        domain: aUserRec?.Domain || "",
        name: aUserRec?.Fullname || "",
        desc: "",
        email: aUserRec?.EmailAddress || "",
        deptCode: vFindDept?.DeptCode || "",
      }
      setUserInfo(vUserInfo);
      // setUserInfo(aUserRec);

      setIsDomainUser(true);
      setOpenUserAddDialog(true);
    }

  }

  const handleClickEdit = () => {

    // console.log("selectedRec", selectedRec);

    if (selectedRec == null)
      return


    setEditMode(true);

    const vUserInfo = {
      userID: selectedRec.UserID || "",
      domain: selectedRec.Domain || "",
      name: selectedRec.FullName || "",
      desc: selectedRec.Desc,
      email: selectedRec.Email || "",
      deptCode: selectedRec.DeptCode || "",
      dataAdmin: (selectedRec.AdminGrade & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData,
      securityAdmin: (selectedRec.AdminGrade & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity,
      disabled: (selectedRec.Status || false) == false,
    }
    // console.log("vUserInfo", vUserInfo);
    setUserInfo(vUserInfo);
    // setUserInfo(aUserRec);

    setIsDomainUser(selectedRec.WinAuth);
    setOpenUserAddDialog(true);


  }


  const handleAfterUserUpdated = () => {
    setOpenUserAddDialog(false);
    refreshData();
  }


  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const [searchText, setSearchText] = useState("");
  const handleSearchTextChange = (e) => {
    const vVal = e.target.value;
    setSearchText(vVal);
    gridApi.setQuickFilter(vVal);
  }

  const [selectedRec, setSelectedRec] = useState(null);
  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();

    let selRecs = nodes.map(item => {
      return item.data
    });

    // setSelectedRecs(selRecs);
    if (selRecs.length > 0) {
      setSelectedRec(selRecs[0])
    } else {
      setSelectedRec(null)
    }

  }


  const [confirmText, setConfirmText] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleClickDelete = () => {
    console.log("selectedRec", selectedRec);
    setConfirmText(`Are you sure to delete the user [${selectedRec.FullName}]?`);
    setOpenConfirmDialog(true);
  }

  const handleConfirmDeleteClick = async () => {
    setOpenConfirmDialog(false);

    setShowLoading(true);
    try {
      await DmsService.memberDelPromise(gState.sessionID, sysID, selectedRec.UserID);

      setShowLoading(false);


      refreshData();

    } catch (e) {
      setShowLoading(false);

      // setErrMsg(e.errMsg || e.message);
      // setShowError(true);
      onCatchPromiseError(e);

    }
  }

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };
  const cellStyle2 = { paddingLeft: '0px', paddingRight: '0px' };

  const GradeRenderer = (params) => {
    return <IconButton color="primary" aria-label="grade picture" component="span">{params.value > 0 && <ManageAccountsIcon />} </IconButton>
  }

  const StatusRenderer = (params) => {
    return <IconButton color="primary" aria-label="status picture" component="span">{params.value !== true && <PersonOffIcon />} </IconButton>
  }

  const DataAdminRenderer = (params) => {
    return <IconButton color="primary" aria-label="dataAdmin picture" component="span">{params.value === true && <CheckIcon />} </IconButton>
  }

  const SecurityAdminRenderer = (params) => {
    return <IconButton color="primary" aria-label="securityAdmin picture" component="span">{params.value === true && <CheckIcon />} </IconButton>
  }

  const WinAuthRenderer = (params) => {
    return <IconButton color="primary" aria-label="systemUser picture" component="span">{params.value === true && <CheckIcon />} </IconButton>
  }

  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorUserID = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.UserID, nodeB.data.UserID)
  }

  const comparatorFullname = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.DisplayName, nodeB.data.DisplayName)
  }

  const comparatorDept = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Department, nodeB.data.Department)
  }

  const columnDefs = useMemo(() => [

    { field: 'Status', headerName: " ", cellStyle: cellStyle2, width: 45, cellRenderer: StatusRenderer, },
    { field: 'AdminGrade', headerName: " ", cellStyle: cellStyle2, width: 45, cellRenderer: GradeRenderer, },
    { field: 'UserID', headerName: "UserID", cellStyle: cellStyle, width: 100, comparator: comparatorUserID, },
    { field: 'DisplayName', headerName: "Fullname", cellStyle: cellStyle, minWidth: 200, flex: "1", comparator: comparatorFullname, },
    { field: 'Domain', headerName: "Domain", cellStyle: cellStyle, width: 100, },
    { field: 'Email', headerName: "Email", cellStyle: cellStyle, minWidth: 150, flex: "1", },
    { field: 'Department', headerName: "Department", cellStyle: cellStyle, minWidth: 150, flex: "1", comparator: comparatorDept, },

    // { field: 'Desc', headerName: "Description", cellStyle: cellStyle, minWidth: 150, flex: "1",  },
    { field: 'DataAdmin', headerName: "Data Admin", cellStyle: cellStyle, width: 100, cellRenderer: DataAdminRenderer, },
    { field: 'SecurityAdmin', headerName: "Security Admin", cellStyle: cellStyle, width: 120, cellRenderer: SecurityAdminRenderer, },
    { field: 'WinAuth', headerName: "Domain User", cellStyle: cellStyle, width: 120, cellRenderer: WinAuthRenderer, },
  ], []);

  const handleGetRowId = useCallback((params) => params.data.UserID, []);

  return (
    // <Box component="div" sx={{ display: 'flex', p: 0, height: 1, maxHeight: 1, overflow: 'auto', bgcolor: 'grey.300' }} >
    <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <SearchDomainUserDialog
        sysID={sysID}
        open={openSearchDomainUserDialog}
        onClose={() => setOpenSearchDomainUserDialog(false)}
        onSelect={handleSelectedDomainUser}
      />
      <UserAddDialog
        sysID={sysID}
        open={openUserAddDialog}
        onClose={() => setOpenUserAddDialog(false)}
        onUpdated={handleAfterUserUpdated}
        editMode={editMode}
        userInfo={userInfo}
        isDomainUser={isDomainUser}
      />


      <Box sx={{ py: 1, px: 1 }} >

        <Button
          startIcon={<PersonAddAlt1Icon />}
          onClick={handleAddDomainUserClick}
        >
          Add
        </Button>

        <Button startIcon={<EditIcon />} onClick={handleClickEdit} disabled={!selectedRec}  >
          Edit
        </Button>

        <Button startIcon={<PersonRemoveAlt1Icon />} onClick={handleClickDelete} disabled={!selectedRec}  >
          Delete
        </Button>
        <ConfirmDialog
          open={openConfirmDialog}
          text={confirmText}
          confirmBtnCaption='Delete'
          onCancelClick={() => setOpenConfirmDialog(false)}
          onConfirmClick={handleConfirmDeleteClick}
        />

      </Box>

      <Box sx={{ flexGrow: 1, pb: 1 }}>
        <TextField
          id="standard-member-search"
          label="Search"
          type="search"
          // variant="standard"
          size="small"
          InputLabelProps={{ shrink: true, }}
          value={searchText}
          onChange={handleSearchTextChange}
        />
      </Box>

      <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
        <AgGridReact

          rowData={gridData}

          defaultColDef={{
            width: 100,
            resizable: true,
            sortable: true,
            suppressMovable: true,
          }}
          columnDefs={columnDefs}
          headerHeight={40}

          suppressNoRowsOverlay

          rowSelection="single"
          onSelectionChanged={onSelectionChanged}

          getRowId={handleGetRowId}
          onGridReady={onGridReady}
        />
      </div>

    </Box>
    // <Box sx={{ flexGrow: 1 }}>
    //     <div style={{ width: '100%', height: '100%' }}>

    //     </div>
    // </Box>


  );
}

UserTab.propTypes = {
  sysID: PropTypes.string,
  // docDetail: PropTypes.object,
  // afterUpdate: PropTypes.func,
};
